module.exports = __webpack_public_path__ + "static/media/left-arrow.a6a31df6.svg";